function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import utils from '@/js/utils';
import configMenu from "@/configs/menus/config.menu";
/*
|---------------------------------------------------------------------
| Language Switcher Component
|---------------------------------------------------------------------
|
| Locale menu to choose the language based on the locales present in
| vue-i18n locales available array
|
*/
export default {
  components: {},
  data: function data() {
    return {
      configMenu: Object.assign([], configMenu)
    };
  },
  props: {
    // Show dropdown arrow
    menu: {
      type: Boolean,
      default: false
    },
    // Show the country label
    showLabel: {
      type: Boolean,
      default: true
    },
    isMini: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauActive', 'isPowerBIActive', 'isDataStudioActive'])), mapState('app', ['menuSelected'])),
  created: function created() {
    //console.log(this.configMenu)
  },
  methods: {
    onOpenUrl: function onOpenUrl(item) {
      this.$router.push({
        name: item.href.name
      });
    },
    requireRole: function requireRole(item) {
      var rolesRequired = item.roles || [];
      var userRoles = window.userInfo.userRoles || [];

      // if both are empty allow pass
      if (rolesRequired.length === 0) {
        return true;
      } else {
        // compare arrays
        var roleFound = utils.findArrayInArray(rolesRequired, userRoles);
        return !!roleFound.length;
      }
    },
    checkFlags: function checkFlags(sub1) {
      if (sub1.checkTableau) {
        if (!this.isTableauActive) return false;
        return true;
      } else if (sub1.checkBI) {
        if (!this.isPowerBIActive) return false;
        return true;
      } else if (sub1.checkDataStudio) {
        if (!this.isDataStudioActive) return false;
        return true;
      } else if (sub1.checkDomain) {
        if (window.userInfo.domain != 'intercorp.com.pe') {
          return false;
        }
        return true;
      } else {
        return true;
      }
    }
  }
};